import { createContext, ReactNode, useContext, useState } from 'react';
import FlipScreen from './components/FlipScreen';
import { FlipOrigin } from './constants';
import { removeFromContext } from './services/contextManager';

export interface FlipScreenOptions {
  toCustomer: boolean;
  additionalMessageType?: 'Decline';
  isFinalFlip?: boolean;
  origin?: FlipOrigin;
}

const FlipScreenContext = createContext<
  (() => null) | ((options: FlipScreenOptions) => Promise<unknown>)
>(() => null);

export const useFlipScreen = () => {
  const flipScreen = useContext(FlipScreenContext);
  return flipScreen;
};

export const FlipScreenProvider = ({ children }: { children: ReactNode }) => {
  const [options, setOptions] = useState<FlipScreenOptions>({
    toCustomer: true,
  });
  const [resolveReject, setResolveReject] = useState<
    Array<(value?: unknown) => void>
  >([]);
  const [resolve] = resolveReject;
  const flipScreen = (options: FlipScreenOptions) => {
    return new Promise((resolve) => {
      setOptions(options);
      setResolveReject([resolve]);
    });
  };

  const handleClose = () => {
    removeFromContext('origin');
    if (resolve) resolve();
    setResolveReject([]);
  };

  return (
    <>
      <FlipScreenContext.Provider value={flipScreen}>
        {children}
      </FlipScreenContext.Provider>
      {resolveReject.length === 1 && (
        <FlipScreen
          isOpen={resolveReject.length === 1}
          options={options}
          onClose={handleClose}
        />
      )}
    </>
  );
};
